import React, { useMemo, useState } from 'react';
import useStyles from 'components/Input/styles';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';

interface IProps {
  type: string;
}

interface IReturn {
  icons: JSX.Element;
  isPasswordInput: boolean;
  openPassword: boolean;
}

export const usePasswordHideShow = ({ type }: IProps): IReturn => {
  const [openPassword, setOpenPassword] = useState(false);

  const classes = useStyles();
  const isPasswordInput = useMemo(() => type === 'password', [type]);

  const icons = useMemo(
    () =>
      openPassword ? (
        <VisibilityIcon
          onClick={() => {
            setOpenPassword(!openPassword);
          }}
          className={classes.icon}
        />
      ) : (
        <VisibilityOffIcon
          onClick={() => {
            setOpenPassword(!openPassword);
          }}
          className={classes.icon}
        />
      ),
    [openPassword],
  );

  return {
    icons,
    isPasswordInput,
    openPassword,
  };
};
